export default __webpack_public_path__ + "static/tutorial-img3-0c86e4f2a56bdc40fb9a934cfbc324ab.png";